import React, { ReactNode } from "react"
import { Box, ButtonBase, Grid2 } from "@mui/material"
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material"
import { BookCopy as InstanceIcon } from "lucide-react"

import { Text } from "@/components/Text"

import useStyles from "@/components/Sidebar/SwitchInstanceButton/styles"

type SwitchInstanceButtonProps = {
	instanceId: string
	instanceName: string
	onClick: () => void
	disabled?: boolean
	isCollapsed?: boolean
	icon?: ReactNode
	variant?: "inbox" | "console"
}

export const SwitchInstanceButton = ({ instanceId, instanceName, onClick, disabled, isCollapsed, icon, variant = "inbox" }: SwitchInstanceButtonProps) => {
	const classes = useStyles()
	const isConsole = variant === "console"

	const cardSx = [classes.card, isConsole && classes.cardSecondary, isCollapsed && classes.cardCollapsed]
	const iconBoxSx = [classes.iconBox, isConsole && classes.iconBoxSecondary]
	const instanceIdTextSx = [classes.instanceIdText, isConsole && classes.instanceIdTextSecondary]
	const instanceNameTextSx = [classes.instanceNameText, isConsole && classes.instanceNameTextSecondary]
	const chevronSx = [classes.chevron, isConsole && classes.chevronSecondary]

	return (
		<Grid2 size={12}>
			<ButtonBase sx={cardSx} onClick={onClick} disabled={disabled}>
				<Box sx={iconBoxSx}>
					{icon ?? <InstanceIcon size={20} />}
				</Box>
				{!isCollapsed && (
					<>
						<Box sx={classes.textContainer}>
							<Text.Body type="smaller2" sx={instanceIdTextSx}>{instanceId}</Text.Body>
							<Text.Body type="smaller2" sx={instanceNameTextSx}>{instanceName}</Text.Body>
						</Box>
						<ChevronRightIcon sx={chevronSx} />
					</>
				)}
			</ButtonBase>
		</Grid2>
	)
}
